import client from "utils/api";
import store from 'utils/store'

function forgotPassword(data){
  return client().post(`/users/password/reset`,data)
    .then((response) => {
      return response.data
    })
    .catch(e => {
      store.dispatch({type:"ADD_TOAST", message:"There was a problem connecting to the server."})

    });
}

function checkToken(token){
  return client().get(`/users/password/`+token)
    .then((response) => {
      return response.data
    })
    .catch(e => {
      store.dispatch({type:"ADD_TOAST", message:"There was a problem connecting to the server."})

    });
}

function resetPassword(token, password){
  return client().post(`/users/password/`+token, {password})
    .then((response) => {
      return response.data
    })
    .catch(e => {
      store.dispatch({type:"ADD_TOAST", message:"There was a problem connecting to the server."})

    });
}


export default {
  forgotPassword,
  checkToken,
  resetPassword
}



// WEBPACK FOOTER //
// ./src/components/password/api.js